/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import moment from 'moment';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import FolderSelector from 'file-browser/FolderSelector';
import SelectTemplateCollectionItemTree from 'notebook/entry-templates/SelectTemplateCollectionItemTree/SelectTemplateCollectionItemTree';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import DateField from 'ui-library/inputs/DateField';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import * as ModalContainer from 'ui-library/ModalContainer';
import Modal from 'ui-library/modals/Modal';
import {MOMENT_DATE_FORMAT} from 'util/DateConstants';

import clampEntryName from './clampEntryName';
import TemplateDAO from './TemplateDAO';

interface Props {
  onRequestClose: (...args: Array<any>) => any;
  onRequestSubmit: (...args: Array<any>) => any;
  initialFolderId?: string;
  initialTemplateId?: string;
  isTemplateSelectorDisabled: boolean;
}

type State = any;

class LegacyCreateEntryFromTemplateModal extends React.Component<Props, State> {
  static close(): void {
    ModalContainer.close(LegacyCreateEntryFromTemplateModal);
  }

  static open(props: any): void {
    // eslint-disable-next-line no-restricted-syntax
    props = _.extend(
      {
        /* eslint-disable-next-line @typescript-eslint/unbound-method */
        onRequestClose: LegacyCreateEntryFromTemplateModal.close,
        isTemplateSelectorDisabled: false,
      },
      props
    );
    ModalContainer.open(
      LegacyCreateEntryFromTemplateModal,
      <LegacyCreateEntryFromTemplateModal {...props} />
    );
  }

  static defaultProps = {
    isTemplateSelectorDisabled: false,
  };

  _isMounted: any;

  override state: State = {
    folderId: this.props.initialFolderId,
    templateId: this.props.initialTemplateId,
    entryName: '',
    initialDay: moment().format(MOMENT_DATE_FORMAT),
  };

  nameRef = React.createRef<HTMLInputElement>();

  handleSubmit = (): void => {
    this.props.onRequestSubmit({
      entryName: this.state.entryName,
      folderId: this.state.folderId,
      templateId: this.state.templateId,
      initialDay: this.state.initialDay,
    });
  };

  changeTemplateHandler = (template: any): void => {
    // Prepopulate entry name with template name
    this.setState({templateId: template.id, entryName: clampEntryName(template.name)});
    _.defer(() => {
      if (this._isMounted) {
        (ReactDOM.findDOMNode(this.nameRef.current) as HTMLInputElement).select();
      }
    });
  };

  override componentDidMount(): void {
    this._isMounted = true;
    if (this.state.templateId) {
      TemplateDAO.get(this.state.templateId).done((template: any) => {
        this.changeTemplateHandler(template);
      });
    }
    (ReactDOM.findDOMNode(this.nameRef.current) as HTMLInputElement).select();
  }

  override componentWillUnmount(): void {
    this._isMounted = false;
  }

  override render(): JSX.Element {
    return (
      <Modal
        title="Create entry from template"
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this.handleSubmit}
        buttons={[
          {
            text: 'Create',
            submit: true,
            disabled:
              this.state.templateId == null || !this.state.entryName.length || this.state.folderId == null,
          },
        ]}
      >
        <Row>
          <Col sm={12}>
            <FormGroup dataTestAttrs={{component: 'LegacyCreateEntryFromTemplateModal', element: 'template'}}>
              <FieldLabel label="Template" isRequired={true} />
              <SelectTemplateCollectionItemTree
                collectibleType="TEMPLATE"
                collectibleId={this.state.templateId || ''}
                setCollectible={(template) => {
                  if (template) {
                    this.changeTemplateHandler(template);
                  }
                }}
              />
            </FormGroup>
          </Col>
          <Col sm={12}>
            <FormGroup
              dataTestAttrs={{component: 'LegacyCreateEntryFromTemplateModal', element: 'initialDay'}}
            >
              <Label>Initial Day</Label>
              <DateField
                labelStyle={DateField.LABEL_STYLES.HIDDEN}
                value={this.state.initialDay}
                onChange={(date: any) => {
                  this.setState({initialDay: date});
                }}
                placeholder=""
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col sm={7}>
            <FormGroup dataTestAttrs={{component: 'LegacyCreateEntryFromTemplateModal', element: 'name'}}>
              <Label>Name</Label>
              <input
                ref={this.nameRef}
                type="text"
                value={this.state.entryName}
                onChange={(e) => {
                  this.setState({entryName: clampEntryName(e.target.value)});
                }}
              />
            </FormGroup>
          </Col>
          <Col sm={5}>
            <FormGroup>
              <Label>Project</Label>
              <FolderSelector
                enableRedesign={true}
                showNotebook={true}
                value={this.state.folderId}
                onChange={(e) => {
                  this.setState({folderId: e.target.value});
                }}
                unsetOnFetchFail={true}
              />
            </FormGroup>
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default LegacyCreateEntryFromTemplateModal;
